import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { merchantApi } from "@api";
import { ArrowLeftColor, ImageUploadIcon } from "@components";
import { PATH_HOME, _10MB } from "@configs";
import { IUploadReceipt } from "@interfaces";
import { selectApp, selectAuth, selectMerchant, setLoading } from "@redux";
import { formatMessage, useNotify } from "@utils";
import { Button, Input, Skeleton } from "antd";
import Jimp from "jimp";
import jsQR from "jsqr";
import { useTranslation } from "react-i18next";
import { QrReader as Qr2 } from "react-qr-reader";
import styled from "styled-components";
//@ts-ignore

export const PageTestPage = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();

    const { loading } = useSelector(selectApp);
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const [receiptImg, setReceiptImg] = useState<any>("");
    const [imgFile, setImgFile] = useState<any>("");
    const { langSetting } = useSelector(selectApp);
    const { success, error, warning } = useNotify();
    const [open, setOpen] = useState<boolean>(false);
    const [opentext, setOpenText] = useState<boolean>(false);
    const [openshowpopup, setOpenShowPopup] = useState<boolean>(false);
    const [tab, setTab] = useState<string>("upload");
    const [sellerCode, setSellerCode] = useState<string>("");
    const [cameraOpen, setCameraOpen] = useState<boolean>(false);
    const [isLine, setIsLine] = useState<boolean>(false);
    const [showImg, setShowImg] = useState<boolean>(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoading, setIsloading] = useState(true);
    //page state

    useEffect(() => {
        let queryParams = new URLSearchParams(window.location.search);
        let open = queryParams.get("open");
        if (open === "scan") {
            setTab("scan");
            setOpenShowPopup(false);
        }

        checkBrowser();
    }, []);

    useEffect(() => {
        if (userInfo?.contact?.sellerId) {
            warning("Seller can not upload recript");
            history.push(PATH_HOME);
        }
    }, [userInfo]);

    useEffect(() => {
        setIsloading(true);
        if (merchant) {
            setIsloading(false);
        }
    });

    const initializeLiff = async () => {
        try {
            const response = await fetch("https://api.line.me/liff/v1/devices/scancodes", {
                method: "POST",
                headers: {
                    Authorization: `Bearer YOUR_LIFF_ACCESS_TOKEN`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ type: "qrcode" }),
            });

            if (response.ok) {
                const result = await response.json();
            } else {
                // การเรียก API ไม่สำเร็จ
                console.error("การสแกน QR Code ไม่สำเร็จ");
            }
        } catch (error) {
            console.error("เกิดข้อผิดพลาดในการเรียกใช้ API:", error);
        }
    };

    const lineQR = async () => {
        try {
            await null;
            // const result = await liff?.scanCdeV2();
            // success(result.value);
        } catch (err: any) {
            warning(typeof err);
        }
    };

    const checkBrowser = async () => {
        await null;
        const userAgent = navigator.userAgent;
        let lowerText: string = userAgent.toLowerCase();
        if (lowerText.includes("line") && lowerText.includes("android")) {
            // from line android
            // await initializeLiff();
            setIsLine(true);
        }
    };

    const previewStyle = {
        height: "100%",
        width: "100%",
    };

    const inputRef = useRef();
    const qrRef = useRef();

    const handleScan = (result: any) => {
        if (result) {
            // setResult(result);
            setSellerCode(result?.data);
            setTab("upload");
        }
    };

    const handleError = (error: any) => {
        console.error(error);
    };

    const changeImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            setReceiptImg("");
            return;
        } else {
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setImgFile(e.target.files[0]);
            setReceiptImg(objectUrl);
        }
    };

    async function findQRCodeInImage(imagePath: string) {
        try {
            const image = await Jimp.read(imagePath);

            image.resize(400, Jimp.AUTO);

            const imageData: any = new Uint8Array(image.bitmap.data.buffer);

            const code = jsQR(imageData, image.bitmap.width, image.bitmap.height);

            if (code) {
                return code.data;
            } else {
                return null;
            }
        } catch (error) {
            console.error("Error processing image:", error);
            return null;
        }
    }

    const changeQr = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target?.files?.[0];
        if (file) {
            let imgUrl = URL.createObjectURL(file);
            findQRCodeInImage(imgUrl)
                .then((code) => {
                    if (code) {
                        setSellerCode(code);
                        success("success add seller");
                        setTab("upload");
                    } else {
                        setSellerCode("");
                        warning("No QR code found in the image.");
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            // const reader = new FileReader();

            // reader.onload = (event) => {
            //     const image = new Image();
            //     image.src = event?.target?.result as string;
            //     image.onload = () => {
            //         const canvas = document.createElement("canvas");
            //         const context = canvas.getContext('2d');
            //         canvas.width = image.width;
            //         canvas.height = image.height;
            //         context?.drawImage(image, 0, 0);
            //         if (context) {

            //             const imageData = context.getImageData(0, 0, image.width, image.height);
            //             const code = jsQR(imageData.data, image.width, image.height);
            //             if (code) {
            //                 setSellerCode(code?.data);
            //                 success("success add seller");
            //                 setTab("upload");
            //             } else {
            //                 setSellerCode("");
            //                 warning("No QR code found in the image.");
            //             }
            //         }
            //     };
            // };
            // reader.readAsDataURL(file);
        }
    };

    const clickImgQr = () => {
        if (qrRef.current) {
            //@ts-ignore
            qrRef.current.click();
        }
    };

    const uploadImage = async (formData: FormData) => {
        try {
            const res = await merchantApi.uploadImage(formData);
            return res.data.publicUrl;
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleConfirm = async () => {
        await null;
        try {
            dispatch(setLoading(true));
            if (isProcessing) {
                // If the button is already processing, do nothing
                return;
            }
            setIsProcessing(true);

            if (receiptImg !== "") {
                if (imgFile.size >= _10MB) {
                    error(t("validation.image.max_size"));
                    dispatch(setLoading(false));
                } else {
                    const formData = new FormData();
                    formData.append("file", imgFile);

                    let imgUrl = await uploadImage(formData);

                    let payload: IUploadReceipt = {
                        merchantId: userInfo?.merchantId || "",
                        userId: userInfo?.contact?.userId || "",
                        userName: userInfo?.username || "",
                        userTel: userInfo?.phoneNumber || "",
                        imageUrl: imgUrl,
                        sellerId: sellerCode,
                    };
                    await merchantApi.uploadReceipt(payload);
                    success(
                        t("page.upload_receipt.success_with_text", {
                            text: merchant?.superAdminTier?.uploadEvidenceDisplay || "",
                        })
                    );
                    history.push(PATH_HOME);
                }
            } else {
                error(t("page.upload_receipt.empty_error"));
                setIsProcessing(false);
            }
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
            setIsProcessing(false);
        } finally {
            dispatch(setLoading(false));
        }
    };
    return (
        <StyledReceiptPage themeColor={themes?.themeColor!}>
            <input
                //@ts-ignore
                ref={qrRef}
                type="file"
                hidden
                id="uploadQr"
                onChange={changeQr}
                accept="image/png, image/jpeg, image/jpg"
            />

            {tab === "upload" && (
                <>
                    <header>
                        <div className="back-arrow">
                            <ArrowLeftColor
                                color={themes?.themeColor}
                                onClick={() => history.push(PATH_HOME)}
                            />
                            <span>{t("page.back")}</span>
                        </div>
                    </header>
                    <div className="step-logo">
                        {/* <div className="step">
                    <p>1</p>
                    <div>&nbsp;</div>
                    <p>2</p>
                </div> */}
                        <Skeleton loading={isLoading} active avatar title={false} paragraph={false}>
                            <div className="logo">
                                <img src={merchant?.themes?.logoSmallUrl} />
                            </div>
                        </Skeleton>
                    </div>
                    <div className="title-receipt">
                        <Skeleton
                            loading={isLoading}
                            active
                            title={{ width: 168 }}
                            paragraph={{ rows: 2, width: [268, 206] }}
                        >
                            <h1>
                                {/* {merchant?.uploadReceiptSetting?.en?.header || t("page.upload_receipt.title")} */}
                                {langSetting?.language === "ENGLISH"
                                    ? merchant?.uploadReceiptSetting?.en?.header ||
                                      t("page.upload_receipt.title")
                                    : merchant?.uploadReceiptSetting?.th?.header ||
                                      t("page.upload_receipt.title")}
                            </h1>
                            {langSetting?.language === "ENGLISH" ? (
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            merchant?.uploadReceiptSetting?.en?.discription || "",
                                    }}
                                ></p>
                            ) : (
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            merchant?.uploadReceiptSetting?.th?.discription || "",
                                    }}
                                ></p>
                            )}
                        </Skeleton>
                    </div>
                    <div className="layout-img-skeleton">
                        <Skeleton
                            loading={isLoading}
                            active
                            title={true}
                            paragraph={{ rows: 1, width: [100] }}
                        >
                            <input
                                //@ts-ignore
                                ref={inputRef}
                                type="file"
                                hidden
                                id="uploadImage"
                                onChange={changeImg}
                                accept="image/png, image/jpeg, image/jpg"
                            />
                            <div className="box-image">
                                {receiptImg === "" ? (
                                    <div className="dont-have-img">
                                        <label className="camera-text" htmlFor="uploadImage">
                                            <ImageUploadIcon color={themes?.themeColor!} />
                                            <p>
                                                + {t("page.upload_receipt.upload_text")}
                                                <span className="color-span">
                                                    {t("page.upload_receipt.receipt")}
                                                </span>
                                            </p>
                                        </label>
                                    </div>
                                ) : (
                                    <div className="have-img">
                                        <label className="camera-text" htmlFor="uploadImage">
                                            <img src={receiptImg} />
                                        </label>
                                    </div>
                                )}
                            </div>
                            <div className="ex-receipt" onClick={() => setOpen(true)}>
                                {langSetting?.language === "ENGLISH"
                                    ? merchant?.uploadReceiptSetting?.en?.exampleButton ||
                                      t("page.upload_receipt.view_example")
                                    : merchant?.uploadReceiptSetting?.th?.exampleButton ||
                                      t("page.upload_receipt.view_example")}
                            </div>
                        </Skeleton>
                        <div className="btn-skeleton">
                            <Skeleton
                                loading={isLoading}
                                active
                                title={false}
                                paragraph={{ rows: 2 }}
                            >
                                {merchant?.uploadReceiptSetting?.isReferSeller ? (
                                    <>
                                        {!isLine ? (
                                            <>
                                                <div
                                                    className="info"
                                                    onClick={() => setOpenText(true)}
                                                >
                                                    <img src="../images/info-em.png" alt="" />
                                                </div>
                                                <Button
                                                    className="view-btn-type-2"
                                                    disabled={sellerCode !== ""}
                                                    onClick={() => setTab("scan")}
                                                >
                                                    {langSetting?.language === "ENGLISH" ? (
                                                        sellerCode !== "" ? (
                                                            <>
                                                                {
                                                                    merchant?.uploadReceiptSetting
                                                                        ?.en.referButton
                                                                }
                                                                : {sellerCode}
                                                            </>
                                                        ) : (
                                                            merchant?.uploadReceiptSetting?.en
                                                                .referButton
                                                        )
                                                    ) : sellerCode !== "" ? (
                                                        <>
                                                            {
                                                                merchant?.uploadReceiptSetting?.th
                                                                    .referButton
                                                            }
                                                            : {sellerCode}
                                                        </>
                                                    ) : (
                                                        merchant?.uploadReceiptSetting?.th
                                                            .referButton
                                                    )}
                                                </Button>
                                            </>
                                        ) : (
                                            <div className="seller-input-section">
                                                <p>รหัสพนักงานที่แนะนำ</p>
                                                <Input
                                                    className="seller-input"
                                                    value={sellerCode}
                                                    onChange={(e) => setSellerCode(e.target.value)}
                                                    suffix={
                                                        <>
                                                            <Button
                                                                className="input-btn"
                                                                onClick={clickImgQr}
                                                            >
                                                                เลือกรูปภาพ
                                                            </Button>
                                                        </>
                                                    }
                                                />
                                            </div>
                                        )}
                                    </>
                                ) : null}
                                {/* <Button className="view-btn" onClick={() => setOpen(true)}>
                        {t("page.upload_receipt.view_example")}
                    </Button> */}
                                <div className="btn-section">
                                    <Button
                                        className="btn confirm"
                                        onClick={handleConfirm}
                                        disabled={isProcessing}
                                    >
                                        {langSetting?.language === "ENGLISH"
                                            ? merchant?.uploadReceiptSetting?.en?.submitButton ||
                                              t("page.confirm")
                                            : merchant?.uploadReceiptSetting?.th?.submitButton ||
                                              t("page.confirm")}
                                    </Button>
                                </div>
                            </Skeleton>
                        </div>
                        {open && (
                            <StyledDrawer themeColor={themes?.themeColor!}>
                                <div className="content-layout">
                                    <div className="content">
                                        <div className="text-title">
                                            {langSetting?.language === "ENGLISH"
                                                ? merchant?.uploadReceiptSetting?.en
                                                      ?.exampleButton ||
                                                  t("page.upload_receipt.example")
                                                : merchant?.uploadReceiptSetting?.th
                                                      ?.exampleButton ||
                                                  t("page.upload_receipt.example")}
                                        </div>
                                        <div className="content-info">
                                            <div
                                                className="img-section"
                                                onClick={() => {
                                                    setShowImg(true);
                                                    setOpen(false);
                                                }}
                                            >
                                                <img
                                                    src={
                                                        merchant?.uploadReceiptSetting
                                                            ?.exampleEvidenceImg
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => setOpen(false)}
                                        >
                                            {t("page.close")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledDrawer>
                        )}
                        {showImg ? (
                            <StyledShowImg themeColor={themes?.themeColor!}>
                                <div className="control-show-img">
                                    <img src={merchant?.uploadReceiptSetting?.exampleEvidenceImg} />
                                </div>
                                <div
                                    className="close-popupinvite"
                                    onClick={() => {
                                        setOpen(true);
                                        setShowImg(false);
                                    }}
                                >
                                    <img src="../images/ic-close-invite.svg" alt="" />
                                </div>
                            </StyledShowImg>
                        ) : null}
                        {opentext && (
                            <StyledDrawer themeColor={themes?.themeColor!}>
                                <div className="content-layout">
                                    <div className="content">
                                        <div className="text-title">
                                            {langSetting?.language === "ENGLISH"
                                                ? merchant?.uploadReceiptSetting?.en.referButton
                                                : merchant?.uploadReceiptSetting?.th.referButton}
                                        </div>
                                        <div className="content-text">
                                            {langSetting?.language === "ENGLISH" ? (
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            merchant?.uploadReceiptSetting?.en
                                                                .referInformationButton || "",
                                                    }}
                                                ></p>
                                            ) : (
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            merchant?.uploadReceiptSetting?.th
                                                                .referInformationButton || "",
                                                    }}
                                                ></p>
                                            )}
                                        </div>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => setOpenText(false)}
                                        >
                                            {t("page.close")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledDrawer>
                        )}
                        {openshowpopup && (
                            <StyledPopupRedeem>
                                <div className="box-popupconfirm">
                                    <img src={merchant?.uploadReceiptSetting?.popupImg} alt="" />
                                    <div
                                        className="box-close"
                                        onClick={() => setOpenShowPopup(false)}
                                    >
                                        <img src="../images/ic-close-receipt.png" alt="" />
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        )}
                    </div>
                </>
            )}
            {tab === "scan" && (
                <>
                    <header>
                        <div className="back-arrow">
                            <ArrowLeftColor
                                color={themes?.themeColor}
                                onClick={() => setTab("upload")}
                            />
                            <span>{t("page.back")}</span>
                        </div>
                    </header>
                    {/* <div className="scan-qr">
                        <QrReader
                            delay={100}
                            style={previewStyle}
                            onError={handleError}
                            onScan={handleScan}
                        />
                    </div> */}
                    {!isLine && (
                        <div className="qr2">
                            <Qr2
                                onResult={(result: any, error) => {
                                    if (result?.text) {
                                        setSellerCode(result?.text);
                                        setTab("upload");
                                    }
                                }}
                                constraints={{ facingMode: "environment" }}
                            />
                        </div>
                    )}

                    <br />
                    <br />
                    <br />
                    <Button className="view-btn" onClick={clickImgQr}>
                        <img src="../images/ic-select-image.png" alt="" />
                        {t("page.upload_receipt.select_img")}
                    </Button>
                </>
            )}
        </StyledReceiptPage>
    );
};

const StyledShowImg = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    .control-show-img {
        img {
            width: 100%;
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;

const StyledPopupRedeem = styled.div`
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    .box-popupconfirm {
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        img {
            width: 100%;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;

const StyledReceiptPage = styled.div<{ themeColor: string }>`
    height: 100dvh;
    padding: 20px;
    position: relative;
    background-color: #fff;
    position: relative;
    .layout-img-skeleton {
        .ant-skeleton {
            .ant-skeleton-title {
                height: 250px;
                border-radius: 16px;
                width: 100% !important;
            }
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                    margin: 0 auto;
                }
            }
        }
        .btn-skeleton {
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    li {
                        height: 52px;
                        border-radius: 16px;
                        width: 100% !important;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .step-logo {
        display: flex;
        justify-content: center;
        .ant-skeleton {
            .ant-skeleton-header {
                text-align: center;
                padding-right: 0;
                span {
                    width: 105px;
                    height: 105px;
                    margin: 0 auto;
                }
            }
        }
        .step {
            display: flex;
            p {
                margin: none;
                background-color: ${(p) => p.themeColor};
                padding: 2px 10px 4px 10px;
                color: ${(p) => p.theme.colors.white};
                border-radius: 100px;
                font-size: 16px;
            }
            div {
                border-top: 3px solid ${(p) => p.themeColor};
                height: 3px;
                width: 20px;
                margin-top: 14px;
            }
        }
        .logo {
            width: 75px;
            height: 75px;
            border-radius: 100%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .info {
        text-align: right;
        margin-bottom: 5px;
        img {
            width: 18px;
        }
    }
    .seller-input-section {
        input {
            border: 1px solid ${(p) => p.themeColor};
            border-radius: 15px;
            height: 68px !important;
            color: black;
        }
        .ant-input-suffix {
            z-index: 0;
        }
        .input-btn {
            color: #ffffff;
            background-color: ${(p) => p.themeColor};
            border-radius: 12px;
            height: 43px;
        }
    }
    .ex-receipt {
        font-size: 12px;
        color: ${(p) => p.themeColor};
        text-decoration: underline;
        text-align: center;
        margin-bottom: 16px;
    }
    .title-receipt {
        margin-bottom: 16px;
        text-align: center;
        .ant-skeleton {
            .ant-skeleton-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                .ant-skeleton-title {
                    margin-top: 15px;
                    margin-bottom: 12px;
                    height: 10px;
                    border-radius: 16px;
                }
                .ant-skeleton-paragraph {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 15px;
                    li {
                        height: 10px;
                        border-radius: 16px;
                    }
                }
            }
        }
        h1 {
            font-size: 28px;
            font-weight: 500;
            color: #01040d;
            margin: 8px 0;
        }
        p {
            color: #96979c;
            font-size: 16px;
            line-height: 19px;
            font-weight: 400;
        }
    }

    .box-image {
        margin: 15px 0px 16px;
        background-color: rgba(0, 162, 147, 0.08);
        border-radius: 20px;
        text-align: center;
        // border: 1px dashed ${(p) => p.themeColor};
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        min-height: 150px;
        .dont-have-img {
            margin: 40px 20px;
            cursor: pointer;
        }
        svg {
            margin-bottom: 10px;
        }
        .have-img {
            margin: 8px;
            img {
                max-width: 100%;
                max-height: 200px;
                border-radius: 16px;
            }
        }
        .color-span {
            color: ${(p) => p.themeColor};
        }
    }
    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .view-btn-type-2 {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        background-color: ${(p) => p.theme.colors.card};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .input-title {
        margin-bottom: 5px;
        margin-top: 40px;
        color: ${(p) => p.themeColor};
    }
    .input-receipt {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .input-receipt:focus {
        outline: none;
        box-shadow: none;
    }
    .scan-qr {
        text-align: center;
        width: calc(100% + 40px);
        margin-left: -20px;
        margin-top: 20px;
        section {
        }
    }

    .btn-section {
        width: 100%;
        position: relative;
        padding: 15px 0;
        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
            span {
                font-weight: 600;
            }
        }
        .back {
            border: 1px solid ${(p) => p.themeColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.themeColor};
            color: white;
            background-color: ${(p) => p.themeColor};
        }
    }
    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
`;

const StyledDrawer = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
    }
    .content-layout {
        width: 100%;
        height: auto;
        min-height: 80dvh;
        .content {
            padding: 20px;
            width: 100%;
            height: 80vh;
            padding-bottom: 28px;
            background: ${(p) => p.theme.colors.card};
            position: relative;
            border-radius: 16px 16px 0 0;
            bottom: 0;
            margin: auto;
            text-align: center;
            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
                transform: rotate(0deg);
                transition: 0.6s;
                &:hover {
                    transform: rotate(90deg);
                }
            }
            .text-title {
                font-weight: 600;
                font-size: 24px;
                color: ${(p) => p.themeColor};
            }
            .content-text {
                margin: 16px 0;
                p {
                    font-size: 14px;
                    line-height: 24px;
                    text-align: left;
                }
            }
            .content-info {
                border-radius: 16px;
                padding: 20px;
                .img-section {
                    background-color: ${(p) => p.themeColor}30;
                    height: 40vh;
                    border-radius: 25px;
                    margin-bottom: 30px;
                    img {
                        max-width: 100%;
                        max-height: 35vh;
                        margin-top: 20px;
                    }
                }
            }
        }
    }
`;
